import React, { useState, useEffect } from 'react';
import { Archive, AlertTriangle } from 'lucide-react';
import '../sections/Sections.css';
import { API_BASE_URL } from '../../config';

const DLQManager = ({ jobId }) => {
    const [events, setEvents] = useState([]);

    useEffect(() => {
        if (!jobId) return;

        const fetchEvents = async () => {
            try {
                const res = await fetch(`${API_BASE_URL}/api/dms/dlq/${jobId}`);
                const data = await res.json();
                if (data.success) {
                    setEvents(data.events || []);
                }
            } catch (err) {
                console.error('Failed to fetch DLQ events', err);
            }
        };

        fetchEvents();
        const interval = setInterval(fetchEvents, 5000);
        return () => clearInterval(interval);
    }, [jobId]);

    // Only render if there are actually failed events
    if (!jobId || events.length === 0) return null;

    return (
        <div className="panel-card panel-span-12" style={{ border: '1px solid rgba(245, 158, 11, 0.3)' }}>
            <div className="panel-header" style={{ borderBottom: '1px solid rgba(245, 158, 11, 0.2)' }}>
                <div className="panel-title" style={{ color: 'var(--obs-warning)' }}>
                    <Archive size={16} />
                    Dead Letter Queue (DLQ)
                </div>
            </div>
            <div className="panel-content">
                <p style={{ fontSize: '0.75rem', color: 'var(--obs-text-muted)', margin: '0 0 0.75rem 0' }}>
                    Transactions that failed to apply on the Target database (e.g. Constraint Violations).
                    These events are dynamically safely stored here to prevent the replication engine from crashing.
                </p>
                <div style={{ maxHeight: '420px', overflowY: 'auto', border: '1px solid rgba(255,255,255,0.05)', borderRadius: '8px' }}>
                    <table className="table-monitor">
                        <thead style={{ position: 'sticky', top: 0, background: 'rgba(245, 158, 11, 0.1)', zIndex: 10 }}>
                            <tr>
                                <th>Timestamp</th>
                                <th>Table</th>
                                <th>Operation</th>
                                <th>Error Message</th>
                                <th>Data Payload</th>
                            </tr>
                        </thead>
                        <tbody>
                            {events.map((e, i) => (
                                <tr key={i} style={{ borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                                    <td style={{ fontSize: '0.75rem', whiteSpace: 'nowrap' }}>{new Date(e.created_at).toLocaleString()}</td>
                                    <td style={{ fontWeight: 600 }}>{e.table_name}</td>
                                    <td>
                                        <span className={`event-op op-${(e.operation_type || 'U').toLowerCase()}`}>
                                            {e.operation_type === 'c' || e.operation_type === 'r' ? 'INSERT' : e.operation_type === 'u' ? 'UPDATE' : e.operation_type === 'd' ? 'DELETE' : e.operation_type}
                                        </span>
                                    </td>
                                    <td style={{ color: 'var(--obs-error)', fontSize: '0.75rem', maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis' }} title={e.error_message}>
                                        <AlertTriangle size={12} style={{ display: 'inline', marginRight: '4px' }} />
                                        {e.error_message}
                                    </td>
                                    <td>
                                        <details style={{ fontSize: '0.7rem', cursor: 'pointer', background: 'rgba(0,0,0,0.2)', padding: '4px 8px', borderRadius: '4px' }}>
                                            <summary style={{ outline: 'none' }}>View JSON</summary>
                                            <pre style={{ margin: '4px 0 0', padding: '8px', background: '#000', borderRadius: '4px', overflowX: 'auto', color: 'var(--obs-success)' }}>
                                                {JSON.stringify(e.payload, null, 2)}
                                            </pre>
                                        </details>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default DLQManager;
